<template>
  <div>
    <v-tabs
      v-model="activeTab"
      background-color="transparent"
      color="secondary"
      show-arrows
      class="mb-3"
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.key"
      >
        <v-icon
          small
          class="mr-1"
        >
          {{ tab.icon }}
        </v-icon>
        {{ tab.label }}
      </v-tab>
    </v-tabs>

    <v-tabs-items
      v-model="activeTab"
      class="transparent"
    >
      <v-tab-item
        v-for="(tab, idx) in tabs"
        :key="tab.key"
      >
        <component
          :is="tab.component"
          :active="activeTab === idx"
          v-bind="tab.props || {}"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
  import ConselhosTab from './dictionaries/ConselhosTab.vue'
  import ReadOnlyDictTab from './dictionaries/ReadOnlyDictTab.vue'
  import ApelidosTab from './dictionaries/ApelidosTab.vue'

  export default {
    name: 'GlobalDictionariesSection',

    components: { ConselhosTab, ReadOnlyDictTab, ApelidosTab },

    data: () => ({
      activeTab: 0,
      tabs: [
        {
          key: 'conselhos',
          label: 'Conselhos',
          icon: 'mdi-account-tie-outline',
          component: 'ConselhosTab',
        },
        {
          key: 'cbhpm',
          label: 'CBHPM',
          icon: 'mdi-medical-bag',
          component: 'ReadOnlyDictTab',
          props: {
            label: 'CBHPM',
            sdkPath: 'cbhpm',
            headers: [
              { text: 'ID', value: 'id', width: 80 },
              { text: 'Edição', value: 'edicao', width: 100 },
              { text: 'Versão', value: 'versao', width: 100 },
              { text: 'Código', value: 'codigo', width: 140 },
              { text: 'Descrição', value: 'descricao' },
              { text: 'Porte', value: 'porte', width: 80 },
            ],
          },
        },
        {
          key: 'cid',
          label: 'CID',
          icon: 'mdi-stethoscope',
          component: 'ReadOnlyDictTab',
          props: {
            label: 'CID',
            sdkPath: 'cid',
            headers: [
              { text: 'ID', value: 'id', width: 80 },
              { text: 'Versão', value: 'versao', width: 100 },
              { text: 'Código', value: 'codigo', width: 120 },
              { text: 'Descrição', value: 'descricao' },
              { text: 'Tipo', value: 'tipo', width: 120 },
            ],
          },
        },
        {
          key: 'convenios',
          label: 'Convênios globais',
          icon: 'mdi-shield-account-outline',
          component: 'ReadOnlyDictTab',
          props: {
            label: 'Convênios',
            sdkPath: 'convenios',
            headers: [
              { text: 'ID', value: 'id', width: 80 },
              { text: 'Descrição', value: 'descricao' },
            ],
          },
        },
        {
          key: 'especialidades',
          label: 'Especialidades',
          icon: 'mdi-doctor',
          component: 'ReadOnlyDictTab',
          props: {
            label: 'Especialidades',
            sdkPath: 'especialidades',
            headers: [
              { text: 'ID', value: 'id', width: 80 },
              { text: 'CBO 2002', value: 'cbo2002', width: 120 },
              { text: 'Descrição', value: 'descricao' },
            ],
          },
        },
        {
          key: 'profissoes',
          label: 'Profissões',
          icon: 'mdi-briefcase-outline',
          component: 'ReadOnlyDictTab',
          props: {
            label: 'Profissões',
            sdkPath: 'profissoes',
            headers: [
              { text: 'ID', value: 'id', width: 80 },
              { text: 'CBO 2002', value: 'cbo2002', width: 120 },
              { text: 'CBO 94', value: 'cbo94', width: 120 },
              { text: 'Tipo', value: 'tipo', width: 130 },
              { text: 'Descrição', value: 'descricao' },
            ],
          },
        },
        {
          key: 'paises',
          label: 'Países',
          icon: 'mdi-earth',
          component: 'ReadOnlyDictTab',
          props: {
            label: 'Países',
            sdkPath: 'paises',
            headers: [
              { text: 'Bandeira', value: 'emoji', width: 70 },
              { text: 'Nome', value: 'nome' },
              { text: 'Sigla', value: 'sigla', width: 80 },
              { text: 'ISO3', value: 'iso3', width: 80 },
              { text: 'DDI', value: 'ddi', width: 80 },
              { text: 'Capital', value: 'capital' },
            ],
          },
        },
        {
          key: 'estados',
          label: 'Estados',
          icon: 'mdi-map-marker-outline',
          component: 'ReadOnlyDictTab',
          props: {
            label: 'Estados',
            sdkPath: 'estados',
            headers: [
              { text: 'ID', value: 'id', width: 80 },
              { text: 'Nome', value: 'nome' },
              { text: 'Sigla', value: 'sigla', width: 100 },
            ],
          },
        },
        {
          key: 'meios_pagamento',
          label: 'Meios de pagamento',
          icon: 'mdi-credit-card-outline',
          component: 'ReadOnlyDictTab',
          props: {
            label: 'Meios de pagamento',
            sdkPath: 'meios_pagamento',
            headers: [
              { text: 'ID', value: 'id', width: 80 },
              { text: 'Descrição', value: 'descricao' },
            ],
          },
        },
        {
          key: 'medicamentos',
          label: 'Medicamentos',
          icon: 'mdi-pill',
          component: 'ReadOnlyDictTab',
          props: {
            label: 'Medicamentos',
            sdkPath: 'medicamentos',
            headers: [
              { text: 'Produto', value: 'produto' },
              { text: 'Substância', value: 'substancia' },
              { text: 'Laboratório', value: 'laboratorio' },
              { text: 'Apresentação', value: 'apresentacao' },
              { text: 'Classe', value: 'classe_terapeutica' },
              { text: 'Tarja', value: 'tarja', width: 100 },
            ],
          },
        },
        {
          key: 'cbhpm_apelidos',
          label: 'Apelidos CBHPM',
          icon: 'mdi-tag-multiple-outline',
          component: 'ApelidosTab',
          props: {
            sdkPath: 'cbhpm_apelidos',
            parentSdkPath: 'cbhpm',
            parentIdField: 'id_dicionario_cbhpm',
            parentLabel: 'Procedimento CBHPM',
            parentDisplay: (item) => [item.codigo, item.descricao].filter(Boolean).join(' — '),
            tableHeaders: [
              { text: 'ID', value: 'id', width: 80 },
              { text: 'Código CBHPM', value: 'cbhpm_codigo', width: 140 },
              { text: 'Procedimento', value: 'cbhpm_descricao' },
              { text: 'Apelido', value: 'apelido' },
              { text: '', value: 'actions', width: 110, sortable: false, align: 'end' },
            ],
          },
        },
        {
          key: 'especialidades_apelidos',
          label: 'Apelidos Especialidades',
          icon: 'mdi-tag-outline',
          component: 'ApelidosTab',
          props: {
            sdkPath: 'especialidades_apelidos',
            parentSdkPath: 'especialidades',
            parentIdField: 'id_dicionario_especialidades',
            parentLabel: 'Especialidade',
            parentDisplay: (item) => [item.cbo2002, item.descricao].filter(Boolean).join(' — '),
            tableHeaders: [
              { text: 'ID', value: 'id', width: 80 },
              { text: 'CBO 2002', value: 'especialidade_cbo2002', width: 120 },
              { text: 'Especialidade', value: 'especialidade_descricao' },
              { text: 'Apelido', value: 'apelido' },
              { text: '', value: 'actions', width: 110, sortable: false, align: 'end' },
            ],
          },
        },
      ],
    }),
  }
</script>
